// extracted by mini-css-extract-plugin
export default {"root":"classes_root__MXpJB","input-field":"classes_input-field__xK+ye","paste-button":"classes_paste-button__RwjcM"};